import { hooks } from "./hookactions"
export let SYSUserAdministration = { hooks }
